import type {UseEntityData} from "crqlar-react-common/dist/components/useEntity";
import type {GastrodatConfig} from "crqlar-react-common/dist/models/integrations/gastrodat/gastrodat.config";
import {GastrodatService} from "crqlar-react-common/dist/services/integrations/gastrodat/gastrodat.service";
import StatsImportLogsTable from "../../common/StatsImportLogsTable";

interface Props {
    gastrodatConfigData: UseEntityData<GastrodatConfig>
}

const Logs = ({gastrodatConfigData}: Props) => (
    <StatsImportLogsTable
        configId={gastrodatConfigData.item.id}
        getStats={GastrodatService.getStats}
        connectorId="gastrodat"
    />
);

export default Logs;
